import { Route } from 'vue-router/types/router';
import { ActionType, LogLevel, LogType } from '@/utils/logTypes';
import { LogFactory } from '@/logger';

const trackPageInteraction = (
  type: string,
  route: Route | null,
  action: ActionType,
) => {
  const performanceTiming = window.performance.timing;
  const latency =
    performanceTiming.loadEventEnd - performanceTiming.navigationStart;
  const latencyValue =
    latency > 0 ? latency : Date.now() - performanceTiming.navigationStart;

  const logData = LogFactory.getLogFormatData(LogLevel.INFO, LogType.PAGE, {
    data: {
      type,
      name: route?.path,
      latency: latencyValue,
    },
  });
  LogFactory.log(LogLevel.INFO, logData, action);
};

export default {
  loggingOpenPage(to: Route, from: Route) {
    trackPageInteraction('Open', to, ActionType.OPEN_PAGE);
  },
  loggingClosePage(to: Route, from: Route) {
    trackPageInteraction('Close', from, ActionType.PAGE_CLOSED);
  },
};
